import { render, staticRenderFns } from "./Quill.vue?vue&type=template&id=c2531b16&"
import script from "./Quill.vue?vue&type=script&lang=js&"
export * from "./Quill.vue?vue&type=script&lang=js&"
import style0 from "./Quill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2531b16')) {
      api.createRecord('c2531b16', component.options)
    } else {
      api.reload('c2531b16', component.options)
    }
    module.hot.accept("./Quill.vue?vue&type=template&id=c2531b16&", function () {
      api.rerender('c2531b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/taskmanager/Quill.vue"
export default component.exports